export function clearInvitationData() {
  localStorage.removeItem('invite-string');
  localStorage.removeItem('invite-email');
  localStorage.removeItem('invite-enterprise-name');
}
